"use client"

import { useState, useEffect, useRef } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Link, useLocation } from "react-router-dom"
import { FiHome } from "react-icons/fi"
import { AiOutlineSolution, AiOutlineTeam, AiOutlineBulb, AiOutlineFundProjectionScreen } from "react-icons/ai"
import { FaRegCalendarAlt, FaSuitcase, FaUserTie, FaHandshake, FaCoins, FaMoneyBill, FaTicketAlt, FaLanguage, FaGraduationCap, FaChalkboardTeacher, FaBullhorn, FaStarOfLife, FaChartArea, FaMoneyCheck, FaFilePowerpoint, FaExchangeAlt, FaClock } from "react-icons/fa"
import { MdBusinessCenter, MdOutlineRateReview, MdLibraryAdd, MdDocumentScanner } from "react-icons/md"
import { Building, Cloud, FolderSymlink, Wallet } from "lucide-react"
import { BsFillPersonBadgeFill } from "react-icons/bs"
import { RiAdminLine } from "react-icons/ri"
import { FaImages } from "react-icons/fa";

const Navbar = () => {
  const [activeTab, setActiveTab] = useState("/")
  const location = useLocation()
  const [hoveredItem, setHoveredItem] = useState(null)
  const [activeSubmenu, setActiveSubmenu] = useState(null)
  const submenuRef = useRef(null)

  useEffect(() => {
    setActiveTab(location.pathname)
  }, [location])

  // Close submenu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (submenuRef.current && !submenuRef.current.contains(event.target)) {
        setActiveSubmenu(null)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  const countrySubmenuItems = [
    { to: "/country", label: "Country", icon: <MdOutlineRateReview /> },
    { to: "/state", label: "State", icon: <MdOutlineRateReview /> },
    { to: "/city", label: "City", icon: <MdOutlineRateReview /> },
  ]

  const matrimonySubmenuItems = [
    { to: "/religion", label: "Religion", icon: <FaRegCalendarAlt /> },
    { to: "/caste", label: "Caste", icon: <FaRegCalendarAlt /> },
    { to: "/mother-tongue", label: "Mother Tongue", icon: <FaLanguage /> },
    { to: "/education", label: "Education", icon: <FaGraduationCap /> },
    { to: "/gothram", label: "Gothram", icon: <FaRegCalendarAlt /> },
    { to: "/dhosam", label: "Dhosam", icon: <FaRegCalendarAlt /> },
    { to: "/occupation", label: "Occupation", icon: <FaRegCalendarAlt /> },
    { to: "/zodiac", label: "Zodiac", icon: <FaRegCalendarAlt /> },
    { to: "/star", label: "Star", icon: <FaRegCalendarAlt /> },
    { to: "/profiles", label: "Profiles", icon: <FaRegCalendarAlt /> },
  ]

  const formBuilderSubmenuItems = [
    { to: "/form-builder", label: "New", icon: <MdLibraryAdd /> },
    { to: "/form-list", label: "List", icon: <MdLibraryAdd /> },
  ]

  return (
    <>
      <motion.aside className="fixed top-0 left-0 h-screen w-20 overflow-y-auto overflow-x-hidden bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900 text-white p-4 z-40 flex flex-col border-r border-slate-700/50 shadow-2xl scrollbar-thin scrollbar-thumb-slate-600/50 scrollbar-track-slate-800/30">
        <nav className="flex-1 flex flex-col space-y-2 text-sm pt-4">
          {/* Top-level items */}
          <NavItem
            to="/"
            icon={<FiHome className="text-[22px]" />}
            label="Home"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/solutions"
            icon={<AiOutlineSolution className="text-[22px]" />}
            label="Tech Support"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />

          <NavItem
            to="/startupideas"
            icon={<Building className="text-[22px]" />}
            label="Startup Ideas"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/events"
            icon={<FaRegCalendarAlt className="text-[22px]" />}
            label="Events"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/programs"
            icon={<FaChartArea className="text-[22px]" />}
            label="Programs"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          {/* Photo Gallery */}
          <NavItem
            to="/event-gallery"
            icon={<FaImages className="text-[22px]" />}
            label="Photo Gallery"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/forums"
            icon={<FolderSymlink className="text-[22px]" />}
            label="Forums"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/appointments"
            icon={<FaClock className="text-[22px]" />}
            label="Appointments"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/appointments/transaction"
            icon={<FaExchangeAlt className="text-[22px]" />}
            label="Appointments transactions"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/mentorpayouts"
            icon={<Wallet className="text-[22px]" />}
            label="Mentor Payout Requests"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/career"
            icon={<MdBusinessCenter className="text-[22px]" />}
            label="Jobs"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />

          <NavItem
            to="/mentor"
            icon={<FaChalkboardTeacher className="text-[22px]" />} // or any mentor-related icon
            label="Add Mentor"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />

          <NavItem
            to="/call-to-action"
            icon={<FaBullhorn className="text-[22px]" />}
            label="Call to Action"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />

          <NavItem
            to="/startup-reg"
            icon={<AiOutlineTeam className="text-[22px]" />}
            label="Startup Registration"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/cofounder-reg"
            icon={<FaUserTie className="text-[22px]" />}
            label="Cofounder Registration"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />

          <NavItem
            to="/hr/applications"
            icon={<FaSuitcase className="text-[22px]" />}
            label="Hr Applications"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/business-idea-hub"
            icon={<AiOutlineBulb className="text-[22px]" />}
            label="Business Ideation Hub"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/business-consultation"
            icon={<FaHandshake className="text-[22px]" />}
            label="Business Consultation"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/coupons"
            icon={<FaStarOfLife className="text-[22px]" />}
            label="Flixbus Coupons"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/tactos-coupons"
            icon={<FaTicketAlt className="text-[22px]" />}
            label="Tactos Coupons"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/fundings"
            icon={<AiOutlineFundProjectionScreen className="text-[22px]" />}
            label="Fundings"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/earnings"
            icon={<FaCoins className="text-[22px]" />}
            label="Earnings"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/admin-testimonial"
            icon={<MdOutlineRateReview className="text-[22px]" />}
            label="Testimonial"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/admin-investors"
            icon={<BsFillPersonBadgeFill className="text-[22px]" />}
            label="Investors"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/admin-pitchdecks"
            icon={<FaFilePowerpoint className="text-[22px]" />}
            label="Investors Pitchdecks"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/addadmin"
            icon={<RiAdminLine className="text-[22px]" />}
            label="Add Admin"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />



          {/* Country Manage */}
          <SubmenuItem
            id="country-manage"
            icon={<MdOutlineRateReview className="text-[22px]" />}
            label="Country Manage"
            submenuItems={countrySubmenuItems}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeSubmenu={activeSubmenu}
            setActiveSubmenu={setActiveSubmenu}
          />

          <NavItem
            to="/datamanager"
            icon={<MdLibraryAdd className="text-[22px]" />}
            label="Add Data"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/documentation"
            icon={<MdDocumentScanner className="text-[22px]" />}
            label="Documentation"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/call-to-expert"
            icon={<MdOutlineRateReview className="text-[22px]" />}
            label="Call to Expert"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/cloud_credits"
            icon={<Cloud className="text-[22px]" />}
            label="Cloud Credits"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/reports"
            icon={<FaTicketAlt className="text-[22px]" />}
            label="Reports"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />

          {/* Matrimony Settings */}
          <SubmenuItem
            id="matrimony-settings"
            icon={<FaRegCalendarAlt className="text-[22px]" />}
            label="Matrimony Settings"
            submenuItems={matrimonySubmenuItems}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeSubmenu={activeSubmenu}
            setActiveSubmenu={setActiveSubmenu}
          />

          <NavItem
            to="/payment-gateway"
            icon={<FaMoneyBill className="text-[22px]" />}
            label="Payment Gateways"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />
          <NavItem
            to="/commission"
            icon={<FaMoneyCheck className="text-[22px]" />}
            label="Commission"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />

          {/* Subscription */}
          <NavItem
            to="/subscription"
            icon={<FaRegCalendarAlt className="text-[22px]" />}
            label="Subscription"
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            hoveredItem={hoveredItem}
            setHoveredItem={setHoveredItem}
          />

          {/* Form Builder */}
          <SubmenuItem
            id="form-builder"
            icon={<MdLibraryAdd className="text-[22px]" />}
            label="Form Builder"
            submenuItems={formBuilderSubmenuItems}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            activeSubmenu={activeSubmenu}
            setActiveSubmenu={setActiveSubmenu}
          />
        </nav>
      </motion.aside>

      {/* Floating Submenu */}
      <AnimatePresence>
        {activeSubmenu && (
          <motion.div
            ref={submenuRef}
            initial={{ opacity: 0, x: -20, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -20, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="fixed submenu-floating-panel left-[75px] z-[2147483647] bg-gradient-to-b from-slate-800 to-slate-900 border border-slate-600/50 rounded-2xl shadow-2xl backdrop-blur-xl min-w-[200px] max-w-[250px]"
            style={{
              top: activeSubmenu.position?.top,
              bottom: activeSubmenu.position?.bottom,
              maxHeight: activeSubmenu.position?.bottom ? "calc(100vh - 40px)" : "calc(100vh - 20px)",
            }}
          >
            <div className="p-4">
              <h3 className="text-sm font-semibold text-gray-300 mb-3 px-2">{activeSubmenu.label}</h3>
            </div>

            {/* Scrollable content area */}
            <div className="max-h-[60vh] overflow-y-auto scrollbar-thin scrollbar-thumb-slate-600/50 scrollbar-track-slate-800/30 pb-4">
              <div className="space-y-2 px-4">
                {activeSubmenu.items.map((item, index) => (
                  <motion.div
                    key={item.to}
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.05 }}
                  >
                    <Link
                      to={item.to}
                      onClick={() => {
                        setActiveTab(item.to)
                        setActiveSubmenu(null)
                      }}
                      className={`flex items-center px-3 py-2 rounded-xl transition-all duration-200 ${activeTab === item.to
                        ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg"
                        : "text-gray-300 hover:bg-slate-700/50 hover:text-white"
                        }`}
                    >
                      <span className="text-[20px] mr-3 flex-shrink-0">{item.icon}</span>
                      <span className="font-medium truncate">{item.label}</span>
                    </Link>
                  </motion.div>
                ))}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

const NavItem = ({ to, icon, label, activeTab, setActiveTab, hoveredItem, setHoveredItem }) => {
  const isActive = activeTab === to
  const buttonRef = useRef(null)
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0 })

  const handleMouseEnter = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect()
      setTooltipPosition({ top: rect.top + rect.height / 2 })
      setHoveredItem({ label })
    }
  }

  return (
    <div className="relative">
      <motion.div
        ref={buttonRef}
        whileTap={{ scale: 0.95 }}
        className="flex items-center w-full"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={() => setHoveredItem(null)}
      >
        <Link
          to={to}
          onClick={() => setActiveTab(to)}
          className={`flex items-center justify-center w-full px-3 py-3 rounded-xl transition-all duration-300 ${isActive
            ? "bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg transform scale-105"
            : "text-gray-300 hover:bg-slate-700/50 hover:text-white hover:transform hover:scale-105"
            }`}
        >
          <span className="text-[22px]">{icon}</span>
        </Link>
      </motion.div>

      {/* Tooltip */}
      <AnimatePresence>
        {hoveredItem?.label === label && (
          <motion.div
            initial={{ opacity: 0, x: -10, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -10, scale: 0.8 }}
            transition={{ duration: 0.2 }}
            className="fixed left-24 bg-gradient-to-r from-slate-800 to-slate-700 text-white px-3 py-2 rounded-xl shadow-2xl border border-slate-600/50 backdrop-blur-xl whitespace-nowrap"
            style={{
              top: tooltipPosition.top,
              zIndex: 2147483647 // Maximum possible z-index
            }}
          >
            <span className="text-sm font-medium">{label}</span>
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-1 w-2 h-2 bg-slate-800 rotate-45 border-l border-b border-slate-600/50"></div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

const SubmenuItem = ({ id, icon, label, submenuItems, activeTab, setActiveTab, activeSubmenu, setActiveSubmenu }) => {
  const hasActiveChild = submenuItems.some((item) => activeTab === item.to)
  const buttonRef = useRef(null)
  const [showTooltip, setShowTooltip] = useState(false)

  const handleMouseEnter = () => {
    setShowTooltip(true)

    const rect = buttonRef.current.getBoundingClientRect()
    const viewportHeight = window.innerHeight
    const submenuHeight = submenuItems.length * 50 + 100

    const spaceBelow = viewportHeight - rect.bottom
    const spaceAbove = rect.top

    let position = { top: rect.top }

    if (spaceBelow < submenuHeight && spaceAbove > submenuHeight) {
      position = { bottom: viewportHeight - rect.top }
    } else if (spaceBelow < submenuHeight && spaceAbove < submenuHeight) {
      position = {
        top: Math.max(20, Math.min(rect.top, viewportHeight - submenuHeight - 20)),
      }
    }

    setActiveSubmenu({
      id,
      label,
      items: submenuItems,
      position,
    })
  }

  const handleMouseLeave = (e) => {
    setShowTooltip(false)

    // Delay hiding submenu to allow moving into submenu without flickering
    setTimeout(() => {
      const submenuHovered = document.querySelector(".submenu-floating-panel:hover")
      if (!submenuHovered) {
        setActiveSubmenu(null)
      }
    }, 200)
  }

  return (
    <div className="w-full relative" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <motion.button
        ref={buttonRef}
        whileTap={{ scale: 0.95 }}
        className={`flex items-center justify-center w-full px-3 py-3 rounded-xl transition-all duration-300 ${hasActiveChild || activeSubmenu?.id === id
          ? "bg-gradient-to-r from-blue-600/20 to-purple-600/20 text-blue-300 border border-blue-500/30"
          : "text-gray-300 hover:bg-slate-700/50 hover:text-white hover:transform hover:scale-105"
          }`}
      >
        <span className="text-[22px]">{icon}</span>
        <span className="absolute -bottom-1 -right-1 w-2 h-2 bg-blue-500 rounded-full opacity-60"></span>
      </motion.button>

      {/* Tooltip on hover */}
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, x: -10, scale: 0.8 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            exit={{ opacity: 0, x: -10, scale: 0.8 }}
            transition={{ duration: 0.2 }}
            className="absolute left-16 top-1/2 transform -translate-y-1/2 z-[2147483647] bg-gradient-to-r from-slate-800 to-slate-700 text-white px-3 py-2 rounded-xl shadow-2xl border border-slate-600/50 backdrop-blur-xl whitespace-nowrap"
          >
            <span className="text-sm font-medium">{label}</span>
            <div className="absolute left-0 top-1/2 transform -translate-y-1/2 -translate-x-1 w-2 h-2 bg-slate-800 rotate-45 border-l border-b border-slate-600/50"></div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default Navbar;